




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import { DxButton, DxPopup, DxLookup, DxSelectBox, DxTextBox, DxCheckBox, DxScrollView, DxTooltip } from 'devextreme-vue';
import DxToolbar from 'devextreme-vue/toolbar'
import { DxForm, DxItem, DxAsyncRule, DxStringLengthRule,DxSimpleItem } from 'devextreme-vue/form';
import CustomStore from 'devextreme/data/custom_store';
import { AgentService } from '../../service/AgentService';
import { ClientDto } from '@/models/client/ClientDto';
import { FeeSheetDto } from '@/models/Fees/FeeSheetDto';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { FilingTypeDto } from '@/models/FilingTypeDto';
import { CurrencyService } from '@/service/CurrencyService';
import { JurisdictionDto } from '@/models/JurisdictionDto';
import Form from "devextreme/ui/form";
import { FeeSheetsService } from '@/service/FeeSheetsService';
import { FeeSheetModalFor, FeeSheetModalType } from '@/models/Fees/FeeTypeEnum';
import _ from "lodash";
import { PhaseTypeService } from '@/service/PhaseTypeService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFormItem,
  DxHeaderFilter,
  DxScrolling
} from 'devextreme-vue/data-grid';
import { DxDateBox , DxTagBox} from 'devextreme-vue';
import DxList from 'devextreme-vue/list';
import DxListItem from 'devextreme-vue/list';
import DevExpress from 'devextreme';
import { PhaseTypeDto } from '../../models/PhaseTypeDto';
import { FeeSheetRowDto, FeeSheetRowTypeEnum } from '../../models/Fees/FeeSheetRowDto';
import { FeeSheetRuleDto, FeeSheetRuleTypeEnum, FeeSheetRuleLevelEnum, FeeSheetRulesSortFunction } from '../../models/Fees/FeeSheetRuleDto';
import { InfractionTypeDto } from '../../models/infractions/InfractionTypeDto';
import { Popup } from '@questelservices/common-vue';
import { AgentDto } from '../../models/agent/AgentDto';
import { FeeSheetMassAdderDto, FeeSheetMassAdderCreationDto } from '../../models/Fees/FeeSheetMassAdderDto';
import { alert } from "devextreme/ui/dialog";
import DataSource from 'devextreme/data/data_source';
import List from "devextreme/ui/list";
import { DxValidator, DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import DxValidationGroup from 'devextreme-vue/validation-group';
import ValidationGroup from "devextreme/ui/validation_group";
import { FileParseFormatService } from '../../service/FileParseFormatService';
import { LoadOptions } from 'devextreme/data/load_options';
import { FileParseFormatDto } from '../../models/file-parsing/FileParseFormatDto';

@Component({
  components: {
    Popup,    
    DxButton,
    DxLookup,
    DxSelectBox,
    DxToolbar,
    DxToolbarItem,        
    DxList,
    DxListItem,
    DxDateBox,
    DxTagBox,
    DxTooltip,
    DxValidationGroup,
    DxValidator, DxRequiredRule, DxCustomRule
  }
})
export default class FileParseFormatCreate extends Vue {
    $refs: Vue['$refs'] & {      
        agentSelectionRef? : List;
        validationGroupRef? : ValidationGroup;
    } = {};

    get AgentSelectionComponent()  {
        return ((this.$refs.agentSelectionRef as any).instance as any);
    }

    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value:boolean) {
        this.hidingDialog();
    }

    fileParseFormats: Array<FileParseFormatDto> = [];
    selecedFormatId: Guid = '';

    constructor() {
        super(); 
        this.loadData();
    }

    async loadData() {
        let fileParseFormatService =  new FileParseFormatService();
        let loadOptions: LoadOptions = {};
        fileParseFormatService.search(loadOptions)
            .then(result => {
                this.fileParseFormats = result.data;
                this.fileParseFormats.unshift(
                    {
                        FileParseFormatId: '',
                        Name: 'Create New Format',
                        FileExtensions: [],
                        FileParseFormatColumns: [],
                        FileParseFormatCalculations: [],
                        DeletedFileParseFormatColumns: []
                    }
                );
            });
    }


    onPopupHidden(e: any) {
        this.selecedFormatId = '';
    }

    confirmCreate() {       
        if (this.selecedFormatId === '') {
            this.$router.push({ name: 'file-parse-format-column' });         
        } else {
            this.$router.push({ name: 'file-parse-format-column', params: { id: this.selecedFormatId, copyFromExisting: 'true' } });
        }        
    }

    hidingDialog() {
        this.$emit('hidingFormatCreate');
    }
}
